import { Component, ViewChild, ElementRef } from "@angular/core";
import {
  NavController,
  LoadingController,
  Loading,
  AlertController
} from "ionic-angular";
import { Geolocation } from "@ionic-native/geolocation";
import "rxjs/add/operator/map";
import { EscolherDependentePage } from "../dependentes/escolherdependente";
import { VerMapaPage } from "../vermapa/vermapa";

declare var google;

@Component({
  selector: "addocorrencia",
  templateUrl: "addocorrencia.html"
})
export class AddOcorrenciaPage {
  loading: Loading;
  geocoder = new google.maps.Geocoder();

  @ViewChild("mapa") mapElement: ElementRef;

  constructor(
    public navCtrl: NavController,
    public geolocation: Geolocation,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController
  ) {}

  ionViewDidLoad() {
    localStorage.removeItem("coord");
    localStorage.removeItem("coord2");
    localStorage.removeItem("coord3");
    localStorage.removeItem("cidade");
    localStorage.removeItem("cidade2");
    localStorage.removeItem("cidade3");
    localStorage.removeItem("estado");
    localStorage.removeItem("estado2");
    localStorage.removeItem("estado3");
    localStorage.removeItem("setMarker");
    this.carregaMapa();
  }

  ionViewWillLeave() {
    localStorage.removeItem("coord");
    localStorage.removeItem("coord2");
    localStorage.removeItem("coord3");
    localStorage.removeItem("cidade");
    localStorage.removeItem("cidade2");
    localStorage.removeItem("cidade3");
    localStorage.removeItem("estado");
    localStorage.removeItem("estado2");
    localStorage.removeItem("estado3");
    localStorage.removeItem("setMarker");
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: "Carregando mapa...",
      dismissOnPageChange: true
    });

    this.loading.present();
  }

  carregaMapa() {
    let map;
    let marker;
    let marker2;
    let marker3;
    let infowindow = new google.maps.InfoWindow({ maxWidth: 200 });
    let geocoder;

    this.showLoading();
    this.geolocation.getCurrentPosition().then(
      position => {
        let latLng = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );
        let mapOptions = {
          center: latLng,
          zoom: 16,
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          disableDefaultUI: true,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
        geocoder = new google.maps.Geocoder();

        var input = document.getElementById("txtEndereco");

        var autocomplete = new google.maps.places.Autocomplete(input);

        autocomplete.setComponentRestrictions({
          country: "br"
        });

        autocomplete.addListener("place_changed", function() {
          var place = autocomplete.getPlace();
          //marker.setPosition(place.geometry.location);

          //primeiro marker
          if (localStorage.getItem("setMarker") === null) {
            if (marker) {
              marker.setPosition(place.geometry.location);
            } else {
              marker = new google.maps.Marker({
                position: place.geometry.location,
                map: map,
                draggable: false,
                icon: "assets/img/icon.png"
              });
            }
            map.fitBounds(place.geometry.viewport);

            var altura = document.getElementById("selecione").clientHeight + 50;
            document.getElementById("confirma").style.top = altura + "px";
            document.getElementById("confirma").style.display = "block";

            geocoder.geocode({ latLng: marker.getPosition() }, function(
              results,
              status
            ) {
              if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                  infowindow.setContent(results[0].formatted_address);
                  infowindow.open(map, marker);
                }

                var arrAddress = results[0].address_components;
                var cidade;
                var estado;

                for (let address_component of arrAddress) {
                  if (
                    address_component.types[0] == "administrative_area_level_2"
                  ) {
                    cidade = address_component.long_name;
                  }

                  if (
                    address_component.types[0] == "administrative_area_level_1"
                  ) {
                    estado = address_component.long_name;
                  }
                }

                let coord =
                  marker.getPosition().lat() + "," + marker.getPosition().lng();
                localStorage.setItem("coord", coord);
                localStorage.setItem("cidade", cidade);
                localStorage.setItem("estado", estado);
              }
            });
          } else if (localStorage.getItem("setMarker") === "1") {
            document.getElementById("confirma").style.display = "none";
            if (marker2) {
              marker2.setPosition(place.geometry.location);
            } else {
              marker2 = new google.maps.Marker({
                position: place.geometry.location,
                map: map,
                draggable: false,
                icon: "assets/img/icon.png"
              });
            }
            map.fitBounds(place.geometry.viewport);
            altura = document.getElementById("selecione").clientHeight + 50;
            document.getElementById("confirma2").style.top = altura + "px";
            document.getElementById("confirma2").style.display = "block";

            geocoder.geocode({ latLng: marker2.getPosition() }, function(
              results,
              status
            ) {
              if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                  infowindow.setContent(results[0].formatted_address);
                  infowindow.open(map, marker2);
                }

                var arrAddress = results[0].address_components;
                var cidade;
                var estado;

                for (let address_component of arrAddress) {
                  if (
                    address_component.types[0] == "administrative_area_level_2"
                  ) {
                    cidade = address_component.long_name;
                  }

                  if (
                    address_component.types[0] == "administrative_area_level_1"
                  ) {
                    estado = address_component.long_name;
                  }
                }

                let coord =
                  marker2.getPosition().lat() +
                  "," +
                  marker2.getPosition().lng();

                localStorage.setItem("coord2", coord);
                localStorage.setItem("cidade2", cidade);
                localStorage.setItem("estado2", estado);
              }
            });
          } else {
            document.getElementById("confirma2").style.display = "none";
            if (marker3) {
              marker3.setPosition(place.geometry.location);
            } else {
              marker3 = new google.maps.Marker({
                position: place.geometry.location,
                map: map,
                draggable: false,
                icon: "assets/img/icon.png"
              });
            }
            map.fitBounds(place.geometry.viewport);
            altura = document.getElementById("selecione").clientHeight + 50;
            document.getElementById("confirma3").style.top = altura + "px";
            document.getElementById("confirma3").style.display = "block";

            geocoder.geocode({ latLng: marker3.getPosition() }, function(
              results,
              status
            ) {
              if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                  infowindow.setContent(results[0].formatted_address);
                  infowindow.open(map, marker3);
                }

                var arrAddress = results[0].address_components;
                var cidade;
                var estado;

                for (let address_component of arrAddress) {
                  if (
                    address_component.types[0] == "administrative_area_level_2"
                  ) {
                    cidade = address_component.long_name;
                  }

                  if (
                    address_component.types[0] == "administrative_area_level_1"
                  ) {
                    estado = address_component.long_name;
                  }
                }

                let coord =
                  marker3.getPosition().lat() +
                  "," +
                  marker3.getPosition().lng();

                localStorage.setItem("coord3", coord);
                localStorage.setItem("cidade3", cidade);
                localStorage.setItem("estado3", estado);
              }
            });
          }
        });

        google.maps.event.addListener(map, "click", function(e) {
          //primeiro marker
          if (localStorage.getItem("setMarker") === null) {
            if (marker) {
              marker.setPosition(e.latLng);
            } else {
              marker = new google.maps.Marker({
                position: e.latLng,
                map: map,
                draggable: false,
                icon: "assets/img/icon.png"
              });
            }
            var altura = document.getElementById("selecione").clientHeight + 50;
            document.getElementById("confirma").style.top = altura + "px";
            document.getElementById("confirma").style.display = "block";

            geocoder.geocode({ latLng: marker.getPosition() }, function(
              results,
              status
            ) {
              if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                  infowindow.setContent(results[0].formatted_address);
                  infowindow.open(map, marker);
                }

                var arrAddress = results[0].address_components;
                var cidade;
                var estado;

                for (let address_component of arrAddress) {
                  if (
                    address_component.types[0] == "administrative_area_level_2"
                  ) {
                    cidade = address_component.long_name;
                  }

                  if (
                    address_component.types[0] == "administrative_area_level_1"
                  ) {
                    estado = address_component.long_name;
                  }
                }

                let coord =
                  marker.getPosition().lat() + "," + marker.getPosition().lng();

                localStorage.setItem("coord", coord);
                localStorage.setItem("cidade", cidade);
                localStorage.setItem("estado", estado);
              }
            });
          } else if (localStorage.getItem("setMarker") === "1") {
            document.getElementById("confirma").style.display = "none";
            if (marker2) {
              marker2.setPosition(e.latLng);
            } else {
              marker2 = new google.maps.Marker({
                position: e.latLng,
                map: map,
                draggable: false,
                icon: "assets/img/icon.png"
              });
            }

            altura = document.getElementById("selecione").clientHeight + 50;
            document.getElementById("confirma2").style.top = altura + "px";
            document.getElementById("confirma2").style.display = "block";

            geocoder.geocode({ latLng: marker2.getPosition() }, function(
              results,
              status
            ) {
              if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                  infowindow.setContent(results[0].formatted_address);
                  infowindow.open(map, marker2);
                }

                var arrAddress = results[0].address_components;
                var cidade;
                var estado;

                for (let address_component of arrAddress) {
                  if (
                    address_component.types[0] == "administrative_area_level_2"
                  ) {
                    cidade = address_component.long_name;
                  }

                  if (
                    address_component.types[0] == "administrative_area_level_1"
                  ) {
                    estado = address_component.long_name;
                  }
                }

                let coord =
                  marker2.getPosition().lat() +
                  "," +
                  marker2.getPosition().lng();

                localStorage.setItem("coord2", coord);
                localStorage.setItem("cidade2", cidade);
                localStorage.setItem("estado2", estado);
              }
            });
          } else {
            document.getElementById("confirma2").style.display = "none";
            if (marker3) {
              marker3.setPosition(e.latLng);
            } else {
              marker3 = new google.maps.Marker({
                position: e.latLng,
                map: map,
                draggable: false,
                icon: "assets/img/icon.png"
              });
            }

            altura = document.getElementById("selecione").clientHeight + 50;
            document.getElementById("confirma3").style.top = altura + "px";
            document.getElementById("confirma3").style.display = "block";

            geocoder.geocode({ latLng: marker3.getPosition() }, function(
              results,
              status
            ) {
              if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                  infowindow.setContent(results[0].formatted_address);
                  infowindow.open(map, marker3);
                }

                var arrAddress = results[0].address_components;
                var cidade;
                var estado;

                for (let address_component of arrAddress) {
                  if (
                    address_component.types[0] == "administrative_area_level_2"
                  ) {
                    cidade = address_component.long_name;
                  }

                  if (
                    address_component.types[0] == "administrative_area_level_1"
                  ) {
                    estado = address_component.long_name;
                  }
                }

                let coord =
                  marker3.getPosition().lat() +
                  "," +
                  marker3.getPosition().lng();

                localStorage.setItem("coord3", coord);
                localStorage.setItem("cidade3", cidade);
                localStorage.setItem("estado3", estado);
              }
            });
          }
        });
      },
      err => {
        let alert = this.alertCtrl.create({
          subTitle:
            "Para uma melhor experiência, por favor ative sua localização e reinicie o aplicativo.",
          buttons: [
            {
              text: "OK"
            }
          ]
        });
        alert.present();
      }
    );

    this.loading.dismiss();
  }

  voltarMapa() {
    this.navCtrl.setRoot(VerMapaPage);
  }

  correto1() {
    document.getElementById("voltar").style.display = "block";
    document.getElementById("proximo").style.display = "block";
    document.getElementById("selecione").innerHTML =
      "<strong>Selecione o segundo endereço ou clique em Próximo para prosseguir.</strong>";
    document.getElementById("confirma").style.display = "none";
    localStorage.setItem("setMarker", "1");
  }

  correto2() {
    document.getElementById("confirma2").style.display = "none";
    document.getElementById("selecione").innerHTML =
      "<strong>Selecione o terceiro endereço ou clique em Próximo para prosseguir.</strong>";
    localStorage.setItem("setMarker", "2");
  }

  incorreto(id) {
    document.getElementById(id).style.display = "none";
  }

  escolherDependente() {
    this.navCtrl.push(EscolherDependentePage, {
      coord: localStorage.getItem("coord"),
      coord2: localStorage.getItem("coord2"),
      coord3: localStorage.getItem("coord3"),
      cidade: localStorage.getItem("cidade"),
      cidade2: localStorage.getItem("cidade2"),
      cidade3: localStorage.getItem("cidade3"),
      estado: localStorage.getItem("estado"),
      estado2: localStorage.getItem("estado2"),
      estado3: localStorage.getItem("estado3")
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/ocorrencias/addocorrencia.ts